import habisIcon from 'assets/icons/png/habis.png';
import textIcon from 'assets/icons/png/Text.png';
import userIcon from 'assets/icons/png/user_black.png';
import tipsIcon from 'assets/icons/png/Tips.png';
import backWIcon from 'assets/icons/png/backW.png';
import backBIcon from 'assets/icons/png/backB.png';
import moreIcon from 'assets/icons/png/more.png';

export default {
  'app:habisIcon': `img:${habisIcon}`,
  'app:textIcon': `img:${textIcon}`,
  'app:userIcon': `img:${userIcon}`,
  'app:tipsIcon': `img:${tipsIcon}`,
  'app:backWIcon': `img:${backWIcon}`,
  'app:backBIcon': `img:${backBIcon}`,
  'app:moreIcon': `img:${moreIcon}`,
};
